
export default ({ left, right }, context) => {
	return ({
		type: "logic",
		value: left.value > right.value,
	});
};